import React, { useState, useRef, useLayoutEffect, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Card } from "primereact/card";
import { FilterMatchMode } from "primereact/api";
import { MultiSelect } from "primereact/multiselect";
import { InputNumber } from "primereact/inputnumber";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from "primereact/checkbox";
import { taxPageRows, taxRowsPerPageOptions } from "./common/envTax";
import { getDataApi1, loadApi, saveApi,loadApi1, saveApi1, delApi1,} from "../services/appApi";
import axios from "axios";
import numeral from "numeral";
import moment from "moment";
import "../assets/css/grid_table.css";
import "../assets/css/card.css";

const Client1099Bs  = () => {

  let emptyRow = {
    account_owner_code_desc: null,
    account_owner_code_mean: null,
    account_owner_lkcd: "",
    additional_info: null,
    basis_reported_to_irs_flag: "",
    business_dba_name: null,
    business_email_address: null,
    business_federal_tax_id: null,
    business_legal_name: null,
    business_phone_number: null,
    client_1099b_id: null,
    client_contact_cell_phone: null,
    client_contact_email_address: null,
    client_contact_home_phone: null,
    client_contact_work_phone: null,
    client_federal_tax_id: null,
    client_federal_tax_id_type: "",
    client_first_name: "",
    client_id: null,
    client_last_name: null,
    client_middle_name: null,
    client_type_desc: null,
    client_type_lkcd: "",
    client_type_mean: null,
    cost_or_basis: null,
    created_by: null,
    creation_date: "",
    date_acquired: null,
    date_sold: null,
    description_of_property: null,
    expense_of_sale: null,
    firm_id: null,
    form_1099b_received_flag: "",
    gain_or_loss: null,
    holding_term_desc: null,
    holding_term_lkcd: "",
    holding_term_mean: null,
    last_update_date: "",
    last_updated_by: null,
    mkt_discount_amount: null,
    payer_name: "",
    proceeds_from_sale: null,
    quantity_sold: null,
    spouse_contact_cell_phone: null,
    spouse_contact_email_address: null,
    spouse_contact_home_phone: null,
    spouse_contact_work_phone: null,
    spouse_federal_tax_id: null,
    spouse_federal_tax_id_type: "",
    spouse_first_name: null,
    spouse_last_name: null,
    spouse_middle_name: null,
    tax_year: null,
    tax_year_description: "",
    wash_sale_loss_disallowed: null
    };

  const [rows, setRows] = useState([]);
  const [showproductDialog, setShowProductDialog] = useState(false);
  const [showProductDtlDialog, setShowProductDtlDialog] = useState(false);
  const [row, setRow] = useState(emptyRow);
  const [selectedRows, setSelectedRows] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [errorDialogVisible, setErrorDialogVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [filters, setFilters] = useState({
      client_first_name: {value: null, matchMode: FilterMatchMode.IN,},
      tax_year: {value: null, matchMode: FilterMatchMode.IN,}
    });
  const [apiErrorDialog, setApiErrorDialog] = useState(sessionStorage.getItem("taxSessionExpired") === "true");
  const toast = useRef(null);
  const dt = useRef(null);
  const fetchStarted = useRef(false);
  const prevExpanRef = useRef([]);
  const [currentMode, setCurrentMode] = useState(''); 
  const [clientNameOptions, setClientNameOptions] = useState([]);
  const [fetchClientFlag, setFetchClientFlag] = useState(false);
  const [deleteRowDialog, setDeleteRowDialog] = useState(false);
  const userId = localStorage.getItem("taxUserId");
  const selectedClientId = localStorage.getItem("taxSelectedClientId");
  const selectedTaxYear = localStorage.getItem("taxSelectedTaxYear") || null;
  const firmId = localStorage.getItem("taxFirmId");

    const fetchRows = async () => {
      try {
        if (!selectedClientId) {
          setRows([]);
          setIsLoading(false);
          return;
        }
        let offset = 0;
        let limit = 25;
        let hasMore = true;
        let allData = [];
        let status = null;
        setIsLoading(true);
        while (hasMore) {
        const response = await getDataApi1(`/ztx_client_1099bs_v/v1/?p_client_id=${encodeURIComponent(selectedClientId)}&p_user_id=${encodeURIComponent(userId || "")}&p_tax_year=${encodeURIComponent(selectedTaxYear ?? "")}&offset=${offset}&limit=${limit}`);
        allData = [...allData, ...response.data.o_return_data_rc];
        status =  response.status;
        hasMore = response.data.hasMore;
        offset = offset + limit;
        }
        if (status == 200 && !hasMore) {
          if (allData.length > 0) {
             toast.current.show({
              severity: 'success',
              summary: 'Success',
              detail: 'Data fetched successfully'
            })
            setRows(allData);
            setIsLoading(false);
          } else {
            //setRows(null);
            setRows([]);
            setIsLoading(false);
          }
          //setSearch(response.data);
        } else {
          //setRows(null);
          setRows([]);
          setIsLoading(false);
          const errorInfo = "Error";

            // Set the error message and display the dialog
          setErrorMessage(errorInfo);
          setErrorDialogVisible(true);
        }

        //setRows(response.data);
      } catch (error) {
        if(axios.isCancel(error) ||  error.name== 'CanceledError') {
        toast.current.show({
          severity: 'warn',
          summary: 'Cancelled',
          detail: 'Request successfully cancelled by the user.',
          life: 3000,
        })
        setIsLoading(false);
      } else {
            // Set the error message and display the dialog
            setIsLoading(false);
            setErrorMessage(error.message);
            setErrorDialogVisible(true);
      }
    }
    };

    useEffect(() => {
                  const fetchClient = async () => {
                    setFetchClientFlag(true);
                    try {
                      let offset = 0;
                      let limit = 25;
                      let hasMore = true;
                      let allData = [];
                      let status = null;
                      while (hasMore) {
                        const response = await getDataApi1(`/ztx_firm_clients_v/v1/?p_user_id=${encodeURIComponent(userId || "")}&p_firm_id=${encodeURIComponent(firmId || "")}&offset=${offset}&limit=${limit}`);
                        allData = [...allData, ...response.data.o_return_data_rc];
                        status = response.status;
                        hasMore = response.data.hasMore;
                        offset = offset + limit;
                      }
                      if (allData.length > 0) {
                        const options = allData.map((item) => ({
                          label: item.client_first_name,
                          value: item.client_id,
                        }));
                        setClientNameOptions(options);
                        console.log(options);
                        setFetchClientFlag(false);
                      }
                    } catch (err) {
                      console.error(err);
                      setFetchClientFlag(false);
                    }
                  };
                  fetchClient();
                }, []);
  useLayoutEffect(() => {
     if(!fetchStarted.current){
    fetchStarted.current=true
    fetchRows();
     }
  }, []);

  const numProceedsFromSaleTemplate = (rowData) => {
    return (rowData.proceeds_from_sale || rowData.proceeds_from_sale === 0 ) ? numeral(rowData.proceeds_from_sale).format('0,0.00') : null;
  };
  const numCostOrBasisTemplate = (rowData) => {
    return (rowData.cost_or_basis || rowData.cost_or_basis === 0 ) ? numeral(rowData.cost_or_basis).format('0,0.00') : null;
  };
  const numAdjAmtTemplate = (rowData) => {
    return (rowData.mkt_discount_amount || rowData.mkt_discount_amount === 0 ) ? numeral(rowData.mkt_discount_amount).format('0,0.00') : null;
  };
  const numGainOrLossTemplate = (rowData) => {
    return (rowData.gain_or_loss || rowData.gain_or_loss === 0 ) ? numeral(rowData.gain_or_loss).format('0,0.00') : null;
  };

  const numProceedsFromSale = (row.proceeds_from_sale || row.proceeds_from_sale === 0 ) ? numeral(row.proceeds_from_sale).format('0,0.00') : null;
  const numCostOrBasis = (row.cost_or_basis || row.cost_or_basis === 0 ) ? numeral(row.cost_or_basis).format('0,0.00') : null;
  const numAdjAmt = (row.mkt_discount_amount || row.mkt_discount_amount === 0 ) ? numeral(row.mkt_discount_amount).format('0,0.00') : null;
  const numGainOrLoss = (row.gain_or_loss || row.gain_or_loss === 0 ) ? numeral(row.gain_or_loss).format('0,0.00') : null;
  
  const hideDialog = () => {
    setShowProductDialog(false);
    setShowProductDtlDialog(false);
    setErrorDialogVisible(false);
  };

  const showNewProduct = () => {
    setRow(emptyRow);
    setCurrentMode('I');
    setShowProductDialog(true);
  };

  const showProduct = (row) => {
    setRow({ ...row });
    setCurrentMode('R');
    setShowProductDialog(true);
}

const showEditProduct = (row) => {
    setRow({ ...row }); 
    setCurrentMode('U');
    setShowProductDialog(true);
  };

const exportCSV = () => {
  dt.current.exportCSV();
};

const getLoadingHeaderContents = () => {
  return (
    <React.Fragment>
      <div className="flex justify-content-center align-items-center min-h-screen p-5">
        <Card className="w-full sm:w-30rem shadow-3 border-1 border-primary overflow-hidden">
            <div style={{backgroundColor: 'var(--primary-color'}} className="text-white p-3 text-center border-round-top">
                <h2 className="m-0">1099Bs Table</h2>
            </div>
            <div className="p-4 text-center bg-white">
                <h3 className="text-900 m-0">The Page is loading...</h3>
            </div>
        </Card>
      </div>
    </React.Fragment>
  );
}
const getLoadedHeaderContents = () => {
                return (
                  <React.Fragment>
                    <div className="header-container">
                      <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                      1099Bs
                      </h2>
                      <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                        <div className="header-container p-1">
                            <style>
                            {`
                              input::placeholder {
                                font-size: 17px; 
                              }
                            `}
                          </style>
                        <span className="p-input-icon-right w-full md:w-auto"> 
                      <InputText
                        type="search"
                        onInput={(e) => setGlobalFilter(e.target.value)}
                        placeholder="Search..."
                        className="w-full lg:w-auto text-sm p-3"
                        style={{ fontSize: '17px' }} 
                      />
                    </span>
                        </div>
                      </h2>
                    </div>
                  </React.Fragment>
                );
              }

  const header = (
    <div className="flex flex-column md:flex-row md:align-items-center justify-content-between">
      {/* <span className="p-input-icon-right w-full md:w-auto">
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full lg:w-auto"
        />
      </span> */}
      <Button
        // label="New"
        icon="pi pi-plus"
        className="p-button-success p-button-rounded p-mr-2"
        onClick={showNewProduct}
        tooltip="New"
        tooltipOptions={{ position: "bottom" }}
      />
      <div className="mt-1 md:mt-0 flex md:flex-1 justify-content-end">
        <Button
          icon="pi pi-upload"
          className="p-button-primary p-button-rounded"
          onClick={exportCSV}
          tooltip="Export"
          tooltipOptions={{ position: "bottom" }}
        />
      </div>
    </div>
  );

  const clientOptions = [...new Set(rows.map((item) =>  item.client_first_name).filter(Boolean)),].map((client_first_name) => ({
    label: client_first_name, value: client_first_name,
  }));

  const taxYearOptions = [...new Set(rows.map((item) =>  item.tax_year).filter(Boolean)),].map((tax_year) => ({
    label: tax_year, value: tax_year,
  }));

  const clientFilterTemplate = (options) => (
    <MultiSelect value={options.value || []} options={clientOptions} onChange={(e) => options.filterApplyCallback(e.value)} placeholder="Select Client"
    display="chip" showClear/>
  )

  const taxYearFilterTemplate = (options) => (
    <MultiSelect value={options.value || []} options={taxYearOptions} onChange={(e) => options.filterApplyCallback(e.value)} placeholder="Select"
    display="chip" showClear/>
  )


  const readBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-eye"
          className="p-button-rounded p-button-primary"
          onClick={() => showProduct(rowData)}
          tooltip="View"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };

  const editBodyTemplate = (rowData) => {
        return (
          <React.Fragment>
            <Button
              icon="pi pi-pencil"
              className="p-button-rounded p-button-secondary"
              onClick={() => showEditProduct(rowData)}
              tooltip="Edit"
              tooltipOptions={{ position: "bottom" }}
            />
          </React.Fragment>
        );
    };

    const saveData = async (currentMode) => {
    if(currentMode === 'I') {
    try {
      const p_param = {
          p_user_id: userId,                                                                           
          p_client_id: row.client_id,                                                                 
          p_tax_year: row.tax_year,                                                                   
          p_account_owner_lkcd: row.account_owner_lkcd,                                               
          p_payer_name: row.payer_name,                                                               
          p_holding_term_lkcd: row.holding_term_lkcd,                                                 
          p_basis_reported_to_irs_flag: row.basis_reported_to_irs_flag,                               
          p_form_1099b_received_flag: row.form_1099b_received_flag,                                   
          p_date_acquired: row.date_acquired    
          ? moment(row.date_acquired)
              .utc()
              .format("YYYY-MM-DDTHH:mm:ss[Z]")
          : null,            
          p_date_sold: row.date_sold    
          ? moment(row.date_sold)
              .utc()
              .format("YYYY-MM-DDTHH:mm:ss[Z]")
          : null,                                           
          p_description_of_property: row.description_of_property,                                     
          p_quantity_sold: row.quantity_sold,                                                         
          p_cost_or_basis: row.cost_or_basis,                                                         
          p_proceeds_from_sale: row.proceeds_from_sale,                                               
          p_mkt_discount_amount: row.mkt_discount_amount,                                             
          p_wash_sale_loss_disallowed: row.wash_sale_loss_disallowed,                                 
          p_expense_of_sale: row.expense_of_sale,                                                     
          p_additional_info: row.additional_info, 
      };
      console.log("Insert p_param: ", p_param);
      const response = await loadApi1(
        p_param,
        "/ztx_client_1099bs/v1/",
      );
      console.log(response);
      console.log(response.data);
      if (response.data.o_success_flag === "Y") {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Data Inserted",
        });
        const newRow = {
          client_1099b_id: response.data.o_client_1099b_id,
          ...row,
        };
        setRows((prev) => [...prev, newRow]);
        setShowProductDialog(false);
        setCurrentMode('');
        setRow(emptyRow);
      } else {
        const err_msg = response.data.o_return_msg;
        toast.current.show({
          severity: "error",
          summary: err_msg,
          detail: "Data Not Inserted",
          life: 3000,
          width: "600px",
        });
        setErrorMessage(err_msg);
        setErrorDialogVisible(true);
      }
    } catch (error) {
      if (axios.isCancel(error) || error.name == "CanceledError") {
        toast.current.show({
          severity: "warn",
          summary: "Cancelled",
          detail: "Request successfully cancelled by the user.",
          life: 3000,
        });
      } else {
        // Set the error message and display the dialog
        setErrorMessage(error.message);
        setErrorDialogVisible(true);
      }
    }
  } else if (currentMode === 'U'){

     const p_param = {                                                                              
	        p_user_id: userId,                                                                                  
          p_client_1099b_id: row.client_1099b_id,                                                     
          p_client_id: row.client_id,                                                                 
          p_tax_year: row.tax_year,                                                                   
          p_account_owner_lkcd: row.account_owner_lkcd,                                               
          p_payer_name: row.payer_name,                                                               
          p_holding_term_lkcd: row.holding_term_lkcd,                                                 
          p_basis_reported_to_irs_flag: row.basis_reported_to_irs_flag,                               
          p_form_1099b_received_flag: row.form_1099b_received_flag,                                   
          p_date_acquired: row.date_acquired    
          ? moment(row.date_acquired)
              .utc()
              .format("YYYY-MM-DDTHH:mm:ss[Z]")
          : null,            
          p_date_sold: row.date_sold    
          ? moment(row.date_sold)
              .utc()
              .format("YYYY-MM-DDTHH:mm:ss[Z]")
          : null,                                                             
          p_description_of_property: row.description_of_property,                                     
          p_quantity_sold: row.quantity_sold,                                                         
          p_cost_or_basis: row.cost_or_basis,                                                         
          p_proceeds_from_sale: row.proceeds_from_sale,                                               
          p_mkt_discount_amount: row.mkt_discount_amount,                                             
          p_wash_sale_loss_disallowed: row.wash_sale_loss_disallowed,                                 
          p_expense_of_sale: row.expense_of_sale,                                                     
          p_additional_info: row.additional_info,                                                                       
    
     };    
   
    console.log("Edit p_param: ", p_param);
    try {
      const response = await saveApi1(
        p_param,
        `/ztx_client_1099bs/v1/`,
      );
      console.log(response);
      if (response.data.o_success_flag === "Y") {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Data Updated",
        });
        setRows((prev) =>
          prev.map((data) =>
            data.client_1099b_id === row.client_1099b_id
              ? { ...row }
              : data,
          ),
        );
        setShowProductDialog(false);
        setCurrentMode('');
      } else {
        const err_msg = response.data.o_return_msg;
        toast.current.show({
          severity: "error",
          summary: err_msg,
          detail: "Data Not Updated",
          life: 3000,
          width: "600px",
        });
        setErrorMessage(err_msg);
      }

      //setRows(response.data);
    } catch (error) {
      if (axios.isCancel(error) || error.name == "CanceledError") {
        toast.current.show({
          severity: "warn",
          summary: "Cancelled",
          detail: "Request successfully cancelled by the user.",
          life: 3000,
        });
      } else {
        // Set the error message and display the dialog
        setErrorMessage(error.message);
        setErrorDialogVisible(true);
      }
    }
  }
  };
  
  
    const hideDeleteRowDialog = () => {
      setDeleteRowDialog(false);
    };
  
    const confirmDeleteRow = (row) => {
      setRow(row);
      setDeleteRowDialog(true);
    };
  
    const deleteRow = async () => {
      const p_param = {
        p_user_id: userId,
        p_client_1099b_id: row.client_1099b_id,
        p_client_id: row.client_id,
      };
      try {
        const response = await delApi1(
          { params: p_param },
          "/ztx_client_1099bs/v1/",
        );
        console.log("Delete res: ", response);
        let successFlag = response.data.o_success_flag;
        if (successFlag === "Y") {
          let _rows = rows.filter(
            (val) => val.client_1099b_id !== row.client_1099b_id,
          );
          setRows(_rows);
          setDeleteRowDialog(false);
          setRow(emptyRow);
          toast.current.show({
            severity: "success",
            summary: "Successful",
            detail: "TaxDocument Deleted",
            life: 3000,
            width: "600px",
          });
        } else {
          let err_msg = response.data.o_return_msg;
          toast.current.show({
            severity: "error",
            summary: err_msg,
            detail: "TaxDocument Not Deleted",
            life: 3000,
            width: "600px",
          });
        }
      } catch (error) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "TaxDocument Deletion Failed",
          life: 3000,
          width: "600px",
        });
      }
    };
  
    const deleteRowDialogFooter = (
      <React.Fragment>
        <Button
          label="No"
          icon="pi pi-times"
          severity="secondary"
          onClick={hideDeleteRowDialog}
        />
        <Button label="Yes" icon="pi pi-check" onClick={deleteRow} />
      </React.Fragment>
    );
  
    const actionBodyDeleteTemplate = (rowData) => {
      return (
        <React.Fragment>
          <Button
            icon="pi pi-trash"
            className="p-button-rounded p-button-warning"
            onClick={() => confirmDeleteRow(rowData)}
            tooltip="Delete"
            tooltipOptions={{ position: "bottom" }}
          />
        </React.Fragment>
      );
    };

  return (
    <div>
      <Toast ref={toast} />
      <div className="col mx-2">
      {isLoading ? getLoadingHeaderContents() : getLoadedHeaderContents()}
      {!isLoading && (
      <div className="card mb-3">
        {/* <div className="text-3xl text-800 font-bold mb-4">1099Bs</div> */}
        <DataTable
          ref={dt}
          value={rows}
          scrollable scrollHeight="flex"     
          selection={selectedRows}
          onSelectionChange={(e) => setSelectedRows(e.value)}
          dataKey="client_1099b_id"
          className="custom-datatable-border"
          tableStyle={{ minWidth: '50rem' }}
          paginator
          rows={taxPageRows}
          rowsPerPageOptions={taxRowsPerPageOptions}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} data"
          globalFilter={globalFilter}
          header={header}
          emptyMessage="No data found"
          stripedRows
          showGridlines
          removableSort
          filters={filters}
          filterDisplay="row"
          onFilter={(e) => setFilters(e.filters)}
        > 

          <Column body={readBodyTemplate} exportable={false} style={{width:'0.75rem' }}></Column>
          <Column body={editBodyTemplate} exportable={false} style={{width:'0.75rem' }}></Column>
          <Column body={actionBodyDeleteTemplate} style={{ width: "0.75rem" }} ></Column>
          {/* <Column field="client_first_name" header="Client" sortable filter showFilterMenu={false} filterElement={clientFilterTemplate}></Column>
          <Column field="tax_year" header="Tax Year" filter showFilterMenu={false} filterElement={taxYearFilterTemplate} bodyStyle={{textAlign: "right"}} sortable></Column> */}
          <Column field="payer_name" header="Payer" sortable></Column>
          <Column field="proceeds_from_sale" header="ProceedsFromSale" body={numProceedsFromSaleTemplate} bodyStyle={{textAlign: "right"}} sortable></Column>
          <Column field="cost_or_basis" header="CostOrBasis" body={numCostOrBasisTemplate} bodyStyle={{textAlign: "right"}} sortable></Column>
          {/* <Column field="mkt_discount_amount" header="AdjAmt" body={numAdjAmtTemplate} bodyStyle={{textAlign: "right"}} sortable></Column> */}
          <Column field="gain_or_loss" header="GainOrLoss" body={numGainOrLossTemplate} bodyStyle={{textAlign: "right"}} sortable></Column>
        </DataTable>
      </div>
      )}

      {/* <Dialog visible={showproductDialog} style={{ width: '37.5rem' }} header="1099Bs" modal className="p-fluid" onHide={hideDialog}>
                
                <label htmlFor="client_first_name">Client</label>
                    <div className="box">
                        {row.client_first_name}
                    </div>

                <label htmlFor="tax_year">Tax Year</label>
                    <div className="box">
                        {row.tax_year}
                    </div>

                <label htmlFor="payer_name">Payer</label>
                    <div className="box">
                        {row.payer_name}
                    </div>

                <label htmlFor="proceeds_from_sale">ProceedsFromSale</label>
                    <div className="box">
                        {numProceedsFromSale}
                    </div>
                <label htmlFor="cost_or_basis">CostOrBasis</label>
                    <div className="box">
                        {numCostOrBasis}
                    </div> */}
                {/* <label htmlFor="mkt_discount_amount">AdjAmt</label>
                    <div className="box">
                        {numAdjAmt}
                    </div> */}
                {/* <label htmlFor="gain_or_loss">GainOrLoss</label>
                    <div className="box">
                        {numGainOrLoss}
                    </div>

            </Dialog> */}
            <Dialog
              // header="Add 1099Bs"
              header={currentMode === 'I' ? "Add 1099Bs" : currentMode === 'U' ? "Update 1099Bs" : currentMode === 'R' ? "View 1099Bs" : "1099Divs"}
              visible={showproductDialog}
              style={{ width: "40rem" }}
              onHide={() => setShowProductDialog(false)}
            >
              <div className="p-fluid">
                <div className="grid">
                  <div className="col-12  field">
                    <label>Client</label>
                    <Dropdown
                      value={row.client_id}
                      disabled = {currentMode === 'R' ? true : false}
                      options={clientNameOptions}
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Select Client"
                      onChange={(e) => {
                        const selectedOption = clientNameOptions.find(
                          (option) => option.value === e.value,
                        );
                        setRow({
                          ...row,
                          client_id: e.value,
                          client_first_name: selectedOption?.label || "",
                        });
                      }}
                    />
                  </div>
                  <div className="col-12  field">
                    <label>Tax Year</label>
                    <InputNumber
                      value={row.tax_year}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={false}
                      onChange={(e) => setRow({ ...row, tax_year: e.value })}
                    />
                  </div>
                  <div className="col-12  field">
                    <label>Payer</label>
                    <InputText
                      value={row.payer_name}
                      disabled = {currentMode === 'R' ? true : false}
                      onChange={(e) => setRow({ ...row, payer_name: e.target.value })}
                    />
                  </div>

                  <div className="col-12  field">
                    <label>Account Owner Lkdc</label>
                    <InputText
                      value={row.account_owner_lkcd}
                      disabled = {currentMode === 'R' ? true : false}
                      onChange={(e) => setRow({ ...row, account_owner_lkcd: e.target.value })}
                    />
                  </div>
                  <div className="col-12  field">
                    <label>Holding Term Lkdc</label>
                    <InputText
                      value={row.holding_term_lkcd}
                      disabled = {currentMode === 'R' ? true : false}
                      onChange={(e) => setRow({ ...row, holding_term_lkcd: e.target.value })}
                    />
                  </div>
                  <div className="col-12  field">
                    <label>Description Of Property</label>
                    <InputTextarea value={row.description_of_property} disabled = {currentMode === 'R' ? true : false} 
                      onChange={(e) => setRow({ ...row, description_of_property: e.target.value })} rows={5} cols={30}
                    />
                  </div>
                  <div className="col-12  field">
                    <label>Additional Info</label>
                    <InputTextarea value={row.additional_info} disabled = {currentMode === 'R' ? true : false} 
                      onChange={(e) => setRow({ ...row, additional_info: e.target.value })} rows={5} cols={30}
                    />
                  </div>
                  <div className="col-12  md:col-6  field">
                      <label>Date Acquired</label>
                      <Calendar
                        value={row.date_acquired ? new Date(row.date_acquired) : null}
                        disabled = {currentMode === 'R' ? true : false}
                        dateFormat="yy-mm-dd"
                        showIcon
                        onChange={(e) =>
                          setRow({ ...row, date_acquired: e.value })
                        }
                      />
                  </div>

                  <div className="col-12  md:col-6  field">
                      <label>Date Sold</label>
                      <Calendar
                        value={row.date_sold ? new Date(row.date_sold) : null}
                        disabled = {currentMode === 'R' ? true : false}
                        dateFormat="yy-mm-dd"
                        showIcon
                        onChange={(e) =>
                          setRow({ ...row, date_sold: e.value })
                        }
                      />
                  </div>

                  <div className="col-12   field">
                    <label>Description </label>
                    <InputTextarea value={row.description_of_property} disabled = {currentMode === 'R' ? true : false} 
                      onChange={(e) => setRow({ ...row, description_of_property: e.target.value })} rows={5} cols={30}
                    />
                  </div>

                  <div className="col-12  md:col-6  field">
                    <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                      <label>Basis Repoted To IRS</label>
                      <Checkbox
                        checked={row.basis_reported_to_irs_flag === "Y"}
                        disabled = {currentMode === 'R' ? true : false}
                        onChange={(e) =>
                          setRow({
                            ...row,
                            basis_reported_to_irs_flag: e.checked ? "Y" : "N",
                          })
                        }
                      />
                    </div>
                  </div>

                  <div className="col-12  md:col-6  field">
                    <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                      <label>Form 1099b Received</label>
                      <Checkbox
                        checked={row.form_1099b_received_flag === "Y"}
                        disabled = {currentMode === 'R' ? true : false}
                        onChange={(e) =>
                          setRow({
                            ...row,
                            form_1099b_received_flag: e.checked ? "Y" : "N",
                          })
                        }
                      />
                    </div>
                  </div>
                  
                  <div className="col-12  md:col-6  field">
                    <label>Quantity Sold</label>
                    <InputNumber
                      value={row.quantity_sold}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={true}
                      mode="decimal"
                      maxFractionDigits={2}
                      inputStyle={{ textAlign: 'right' }}
                      onValueChange={(e) => setRow({ ...row, quantity_sold: e.value })}
                    />
                  </div>
                  <div className="col-12  md:col-6  field">
                    <label>Cost Or Basis</label>
                    <InputNumber
                      value={row.cost_or_basis}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={true}
                      mode="decimal"
                      maxFractionDigits={2}
                      inputStyle={{ textAlign: 'right' }}
                      onValueChange={(e) => setRow({ ...row, cost_or_basis: e.value })}
                    />
                  </div>
                  <div className="col-12  md:col-6  field">
                    <label>Proceeds From Sale</label>
                    <InputNumber
                      value={row.proceeds_from_sale}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={true}
                      mode="decimal"
                      maxFractionDigits={2}
                      inputStyle={{ textAlign: 'right' }}
                      onChange={(e) => setRow({ ...row, proceeds_from_sale: e.value })}
                    />
                  </div>
                  <div className="col-12  md:col-6  field">
                    <label>MKT Discount Amount</label>
                    <InputNumber
                      value={row.mkt_discount_amount}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={true}
                      mode="decimal"
                      maxFractionDigits={2}
                      inputStyle={{ textAlign: 'right' }}
                      onValueChange={(e) => setRow({ ...row, mkt_discount_amount: e.value })}
                    />
                  </div>
                  <div className="col-12  md:col-6  field">
                    <label>Wash Sale Loss Disallowed</label>
                    <InputNumber
                      value={row.wash_sale_loss_disallowed}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={true}
                      mode="decimal"
                      maxFractionDigits={2}
                      inputStyle={{ textAlign: 'right' }}
                      onValueChange={(e) => setRow({ ...row, wash_sale_loss_disallowed: e.value })}
                    />
                  </div>
                  <div className="col-12  md:col-6  field">
                    <label>Expense Of Sale</label>
                    <InputNumber
                      value={row.expense_of_sale}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={true}
                      mode="decimal"
                      maxFractionDigits={2}
                      inputStyle={{ textAlign: 'right' }}
                      onValueChange={(e) => setRow({ ...row, expense_of_sale: e.value })}
                    />
                  </div>
                </div>
                
                <div
                  style={{
                    marginTop: "1rem",
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "0.5rem",
                  }}
                >
                  <Button
                    label="Cancel"
                    icon="pi pi-times"
                    severity="secondary"
                    onClick={() => {
                      setShowProductDialog(false);
                      setRow(emptyRow);
                      setCurrentMode('');
                    }}
                  />
                  <Button label="Save" icon="pi pi-check" onClick={(e) => saveData(currentMode)} />
                </div>
              </div>
            </Dialog>
            <Dialog
              visible={deleteRowDialog}
              style={{ width: "450px" }}
              header="Confirm"
              modal
              footer={deleteRowDialogFooter}
              onHide={hideDeleteRowDialog}
            >
              <div className="confirmation-content">
                <i
                  className="pi pi-exclamation-triangle p-mr-3"
                  style={{ fontSize: "1.25rem", marginRight: "0.5rem" }}
                />
                {row && (
                  <span>
                    Are you sure you want to delete <b>{row.machine_name}</b>?
                  </span>
                )}
              </div>
            </Dialog>
            {!apiErrorDialog && (
            <Dialog 
                header="API Error" 
                visible={errorDialogVisible} 
                style={{width: '25rem'}} 
                onHide={hideDialog} 
                footer={
                    <Button label="OK" onClick={hideDialog} className="p-button-primary p-button-rounded" />
                }
            >    
             <p>

                    {errorMessage}
                </p>
            </Dialog>
            )}
            </div>
    </div>
  );
};

export default Client1099Bs;